import { useState } from 'react'

export const useTablePagination = (
	{ defaultPage, defaultPageSize } = {
		defaultPage: 1,
		defaultPageSize: 50,
	}
) => {
	const [page, setPage] = useState(defaultPage)
	const [pageSize, setPageSize] = useState(defaultPageSize)

	const handlePageSizeChange = (current: number, size: number) => {
		setPageSize(size)
		if (current) {
			setPage(current)
		}
	}

	return {
		onShowSizeChange: handlePageSizeChange,
		pageSize,
		current: page,
		onChange: setPage,
		showQuickJumper: true,
		showSizeChanger: true,
	}
}

export const useTableSorting = () => {
	const [column, setColumn] = useState({})

	const handleTableChange = (_: any, __: any, sorter: any) => {
		const order = sorter.order === 'descend' ? 'desc' : 'asc'
		setColumn({ field: sorter.field, order })
	}

	return {
		...column,
		handleTableChange,
	}
}
